import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero" id = "home">
      <div className="hero-content">
        <span className="hero-pill">WEB · MOBILE · SOFTWARE · GAMES</span>

        <h1>
          Building Digital <br />
          Experiences <span>That Power</span> <br />
          <span>the Future</span>
        </h1>

        <p>
          Shirdhankar Technologies delivers cutting-edge web, mobile,
          software, and game development solutions to help businesses innovate.
        </p>

        <div className="hero-buttons">
          <a href="#services" className="primary">Explore Services</a>
          <a href="#contact" className="secondary">Contact Us</a>

        </div>
      </div>

      {/* Floating Icons */}
    </section>
  );
};

export default Hero;
